import React from 'react';
import { connect } from 'react-redux';

import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';

// eslint-disable-next-line
import style from './_style.css';

class HeaderMenu extends React.Component {
    render() {
        const { session, info } = this.props;
        const { nombre, apellidos, foto } = session.info;
        return (
            <div className={'flex_auto_row header-user-menu padding_borders_flat'}>
                <Avatar className={'avatar-user-menu margin_top__18'}>
                    {foto && <img src={foto} alt="Preview" />}
                    {!foto && (
                        <AccountCircle
                            className={'bg_bluish'}
                            style={{ fontSize: 84 }}
                            onClick={this.openAvatarDialog}
                        />
                    )}
                </Avatar>
                <div className={'flex_full_column margin_left_12'}>
                    <div className={'barlowsemicondensed_regular c_dark_grey_blue margin_bottom_5'}>
                        {`${nombre} ${apellidos}`}
                    </div>
                    <div className={'barlow_medium_italic c_slate_grey'}>
                        {info && info.security && info.security.hierarchies
                            ? info.security.hierarchies.name
                            : ''}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        session: state.session,
        info: state.info,
    };
};

HeaderMenu = connect(
    mapStateToProps,
    null,
)(HeaderMenu);

export default HeaderMenu;



// WEBPACK FOOTER //
// ./src/components/navbar/user/Header.js